<template>
	<span :class="!text ? 'text-muted' : ''">
		{{ text || 'Sin definir' }}
	</span>
</template>

<script>
export default {
	name: 'TextValue',
	props: {
		value: {
			type: [String, Number],
			required: false
		}
	},
	computed: {
		text() {
			return this.value.trim();
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
